<template>
  <b-card>
    <b-card-header>
      <h4 class="title">
        لیست نامه های بسته شده
      </h4>
    </b-card-header>
    <b-card-body>
      <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          variant="success"
          class="mb-1 float-right"
          target="_blank"
          :href="exportExcel"
      >
        <feather-icon
            icon="FileTextIcon"
            class="mr-50"
        />
        <span class="align-middle">خروجی اکسل</span>
      </b-button>
      <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          v-b-toggle.filter-box
          variant="outline-primary"
          class="mb-1"
      >
        <feather-icon
            icon="FilterIcon"
            class="mr-50"
        />
        <span class="align-middle">جستجو</span>
      </b-button>
      <b-collapse
          id="filter-box"
          class="mb-2"
      >
        <b-card class="border mb-0">
          <b-form @submit.prevent>
            <b-row>
              <b-col md="4">
                <b-form-group>
                  <label>شماره نامه:</label>
                  <b-form-input
                      v-model="search.id"
                      placeholder="شماره نامه را وارد نمایید."
                      type="text"
                      class="d-inline-block"
                  />
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group>
                  <label>عنوان نامه:</label>
                  <b-form-input
                      v-model="search.title"
                      placeholder="عنوان را وارد نمایید."
                      type="text"
                      class="d-inline-block"
                  />
                </b-form-group>
              </b-col>
              <b-col md-4>
                <b-form-group>
                  <label>متن شامل:</label>
                  <b-form-input
                      v-model="search.description"
                      placeholder="بخشی از متن را وارد نمایید."
                      type="text"
                      class="d-inline-block"
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label>متن پیامک شامل:</label>
                  <b-form-input
                      v-model="search.sms"
                      placeholder="بخشی از متن پیامک را وارد نمایید."
                      type="text"
                      class="d-inline-block"
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                    label=" تاریخ ایجاد(شروع)"
                    label-for="due-date"
                >
                  <date-picker
                      v-model="search.createdDate"
                      type="date"
                      display-format="jDD jMMMM jYYYY"
                      format="YYYY-MM-DD"
                      clearable
                  />

                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                    label=" تاریخ ایجاد(پایان)"
                    label-for="due-date"
                >
                  <date-picker
                      v-model="search.createdDateTo"
                      type="date"
                      display-format="jDD jMMMM jYYYY"
                      format="YYYY-MM-DD"
                      :min="search.createdDate"
                      clearable
                  />

                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="permissions">
                    درجه اهمیت
                  </label>
                  <b-overlay :show="!prioritiesList.length">
                    <v-select
                        v-model="search.priorities"
                        multiple
                        dir="rtl"
                        label="title"
                        :options="prioritiesList"
                        :reduce="priority => priority.id"
                    />
                  </b-overlay>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label>نام کاربر دریافت کننده :</label>
                  <b-form-input
                      v-model="search.receiver"
                      placeholder="نام کاربر را وارد نمایید."
                      type="text"
                      class="d-inline-block"
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="role">
                    کاربران دریافت کننده
                  </label>
                  <v-select
                      v-model="search.users"
                      dir="rtl"
                      label="name"
                      :options="receiversList"
                      :reduce="receiver => receiver.id"
                      :filterable="false"
                      @search="onSearch"
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="role">
                    وضعیت پاسخ
                  </label>
                  <v-select
                      v-model="search.replied"
                      dir="rtl"
                      label="name"
                      :options="repliedList"
                      :reduce="replied => replied.value"
                      :filterable="false"
                      @search="onSearch"
                  />
                </b-form-group>

              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">

                <b-form-group>
                  <div class="demo-inline-spacing">
                    <label for="role">
                      وضعیت مشاهده:
                    </label>
                    <b-form-radio
                        v-model="search.unseen"
                        name="some-radios"
                        value=""
                    >
                      همه
                    </b-form-radio>
                    <b-form-radio
                        v-model="search.unseen"
                        name="some-radios"
                        value="0"
                    >
                      دیده شده
                    </b-form-radio>
                    <b-form-radio
                        v-model="search.unseen"
                        name="some-radios"
                        value="1"
                    >
                      دیده نشده
                    </b-form-radio>
                  </div>
                </b-form-group>
              </b-col>
              <b-col md="6">

                <b-form-group>
                  <div class="demo-inline-spacing">
                    <label for="status">
                      وضعیت نهایی:
                    </label>
                    <b-form-radio
                        v-model="search.isClosed"
                        name="status-radios"
                        value=""
                    >
                      همه
                    </b-form-radio>
                    <b-form-radio
                        v-model="search.isClosed"
                        name="status-radios"
                        value="1"
                    >
                      بسته شده
                    </b-form-radio>
                    <b-form-radio
                        v-model="search.isClosed"
                        name="status-radios"
                        value="0"
                    >
                      بسته نشده
                    </b-form-radio>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
<!--              <b-col md="4">-->
<!--                <b-form-checkbox-->
<!--                    v-model="search.replied"-->
<!--                    checked="false"-->
<!--                    name="check-button"-->
<!--                    class="custom-control-success"-->
<!--                    switch-->
<!--                    inline-->
<!--                >-->
<!--                  فقط نامه های دارای پاسخ-->
<!--                </b-form-checkbox>-->
<!--              </b-col>-->
              <b-col md="4">
                <b-form-checkbox
                    v-model="search.forwarded"
                    checked="false"
                    name="check-button"
                    switch
                    inline
                >
                  فقط نامه های دارای باز ارسال
                </b-form-checkbox>
              </b-col>
            </b-row>
            <hr>
            <div class="demo-inline-spacing">
              <b-button
                  type="submit"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="primary"
                  @click="advanceSearch"
              >
                اعمال جستجو
              </b-button>
              <b-button
                  type="button"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-secondary"
                  @click="clearSearch"
              >
                حذف فیلترها
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-collapse>
      <b-overlay :show="onProgress">
        <div ref="resultTable">
          <b-table
              :fields="fields"
              :items="items"
              hover
              striped
              responsive
              show-empty
              empty-text="رکوردی یافت نشد"
          >
            <template #cell(priority)="data">
              <b-badge
                  :variant="data.value.label"
                  class="mr-1"
              >
                {{ data.value.title }}
              </b-badge>
            </template>
            <template #cell(title)="data">
              <b-avatar
                  v-show="data.item.type.key !== 'SENT'"
                  :id="`invoice-row-${data.item.id}`"
                  v-b-tooltip.hover
                  :title="data.item.type.title"
                  size="32"
                  variant="light-primary"
              >
                <feather-icon
                    :icon="data.item.type.icon"
                />
              </b-avatar>
              {{ data.value }}

              <feather-icon
                  v-show="data.item.attachmentCount"
                  :id="`invoice-row-${data.item.id}`"
                  icon="PaperclipIcon"
              />
            </template>
            <template #cell(receiver)="data">
              {{ data.value.name }}
            </template>

            <template #cell(updatedDate)="data">
              <bdi>{{ data.value }}</bdi>
            </template>

            <template #cell(action)="data">

              <b-button
                  v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                  variant="flat-primary"
                  :to="{name: 'Tickets_Detail', params:{id: data.item.id}}"
              >
                <feather-icon
                    icon="FileTextIcon"
                    class="mr-50"
                />
                <span class="align-middle">مشاهده</span>
              </b-button>
            </template>

          </b-table>
          <b-pagination
              v-model="currentPage"
              class="mt-2"
              :total-rows="totalRows"
              :per-page="perPage"
          />
        </div>
      </b-overlay>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BTable,
  BOverlay,
  BPagination,
  BBadge,
  BAvatar,
  BButton,
  VBTooltip,
  BCollapse,
  BFormInput,
  BRow,
  BCol,
  BFormGroup,
  VBToggle,
  BFormRadio,
  BFormCheckbox,BForm
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import VSelect from 'vue-select'
import { doubleRaf, queryString } from '@/libs/utils'
import { debounce } from '@/libs/debounce'

export default {
  name: 'SaleGroupList',
  components: {
    BFormCheckbox,
    BFormGroup,
    BCol,
    BRow,
    BFormInput,
    VSelect,
    BCollapse,
    BAvatar,
    BCard,
    BCardHeader,
    BCardBody,
    BTable,
    BOverlay,
    BPagination,
    BBadge,
    BButton,
    BFormRadio,BForm
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
    'b-toggle': VBToggle,

  },
  data() {
    return {
      items: [],
      fields: [
        {
          key: 'id',
          label: 'شماره نامه',
        },
        {
          key: 'title',
          label: 'عنوان',
        },
        {
          key: 'priority',
          label: 'درجه اهمیت',
        },
        {
          key: 'receiver',
          label: 'دریافت کننده',
        },
        {
          key: 'creator.name',
          label: 'ایجاد کننده',
        },
        {
          key: 'updatedDate',
          label: 'آخرین بروزرسانی',
        },
        {
          key: 'action',
          label: 'عملیات',
        },
      ],
      onProgress: false,
      currentPage: 1,
      totalRows: 0,
      perPage: 0,
      search: {},
      receiversList: [],
      repliedList: [{name:'دارای پاسخ',value:true},{name:'بدون پاسخ',value:false}],
      getReceivers: false,
      onExportProgress: false,
      prioritiesList: [],
    }
  },
  computed: {
    exportExcel() {
      const query = queryString(this.search)
      return `${process.env.VUE_APP_API}tickets/closed?export-excel=1&${query}`
    },
  },
  methods: {
    async getTicketsList() {
      const currentQuery = JSON.parse(JSON.stringify(this.$route.query))
      this.onProgress = true
      this.$http.get('tickets/closed', {
        params: {
          ...currentQuery,
          ...this.search,
          page: this.currentPage,
        },
      })
          .then(({ data }) => {
            if (data.status) {
              this.items = data.tickets
              this.currentPage = data.meta.current_page
              this.totalRows = data.meta.total
              this.perPage = data.meta.per_page
            } else {
              this.$bvToast.toast(data.message ?? 'لیست نامه ها دریافت نشد', {
                title: 'خطای دریافت اطلاعات',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
          .finally(() => {
            this.onProgress = false
          })
    },
    getRelatedUsers(q) {
      this.$http.get(`tickets/related-users?name=${q}`)
          .then(({ data }) => {
            if (data.status) {
              this.receiversList = data.users
              this.getReceivers = true
            } else {
              this.$bvToast.toast(data.message ?? 'دریافت لیست دریافت کنندگان با خطا مواجه شد', {
                title: 'حطا',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
    },
    getPriorities() {
      this.$http.get('tickets/priorities')
          .then(({ data }) => {
            if (data.status) {
              this.prioritiesList = data.priorities
            } else {
              this.$bvToast.toast(data.message ?? 'دریافت لیست اولویت ها با خطا مواجه شد', {
                title: 'حطا',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
    },
    advanceSearch() {
      this.$router.replace({
        name: this.$route.name,
        query: {
          ...this.search,
        },
      })
          .then(() => {
            this.getTicketsList()
          })
          .catch(() => {
          })

      doubleRaf(() => {
        this.$refs.resultTable.scrollIntoView({ behavior: 'smooth' })
      })
    },
    clearSearch() {
      this.$router.replace({
        name: this.$route.name,
        query: {},
      })
          .then(() => {
            this.getTicketsList()
          })
          .catch(() => {
          })

      this.search = {}
      doubleRaf(() => {
        this.$refs.resultTable.scrollIntoView({ behavior: 'smooth' })
      })
    },
    setSearchData() {
      doubleRaf(() => {
        this.search = JSON.parse(JSON.stringify(this.$route.query))
      })
    },
    onSearch(search, loading) {
      if (search.length) {
        loading(true)
        this.searchUser(loading, search, this)
      }
    },
    searchUser: debounce((loading, search, vm) => {
      vm.getRelatedUsers(search)
      loading(false)
    }, 400),
  },
  watch: {
    currentPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$router.push({
          name: 'Tickets_Closed',
          query: { page: this.currentPage },
        })
        this.items = []
        this.getTicketsList()
      }
    },
  },
  mounted() {
    this.getTicketsList()
    this.getPriorities()
    this.setSearchData()
  },
}
</script>

<style>

</style>
